import type { ChangeEvent, FocusEvent, FunctionComponent } from 'react';
import styled from 'styled-components';
import { PositionAndSizeFromProps } from '../../utils/styledcomponents';
import type { PositionAndSizeProps } from '../../utils/styledcomponents';

const Input = styled.input.attrs({ type: 'text' })`
	border: 0 none;
	border-radius: 3.5vmin;
	color: ${(props) => props.theme.colors.black};
	font: ${(props) => props.theme.font.input};
	font-size: 5.6vmin;
	padding: 1vmin 4vmin;
	&:focus {
		outline: none;
	}
`;

interface Props {
	className?: string;
	value: string;
	onChange: (value: string) => void;
	autoFocus?: boolean;
	maxLength?: number;
}

const TextField: FunctionComponent<Props> = (props: Props) => {
	const { className, value = '', onChange, ...otherProps } = props;

	return (
		<Input
			className={className}
			value={value}
			onChange={(event: ChangeEvent<HTMLInputElement>) =>
				onChange(event.target.value)
			}
			onFocus={(event: FocusEvent<HTMLInputElement>) => event.target.select()}
			{...otherProps}
		/>
	);
};

export default styled(TextField)<PositionAndSizeProps>(
	PositionAndSizeFromProps
);
